<template>
    <section class="onboarding-de onboarding-study">
        <progress-bar 
            :question-number="questionNumber" 
            :number-of-tabs="numberOfTabs - 1" 
            @goBack="prevTab" 
            v-if="showBackButton">
        </progress-bar>

        <div v-if="uuid" class="container">
            <template v-for="tab in tabs">
                <component 
                    :is="getComponent(tab)" 
                    v-if="showTab(tab)" 
                    :uuid="uuid" 
                    :data="apiData" 
                    :type="type"
                    :key="tab"
                    @clicked="setDataFromChild">
                </component>
            </template>
        </div>

        <study-quiz-modal v-if="this.questionNumber === 1"></study-quiz-modal>
    </section>
</template>

<script>
import StudyQuizQuestionWelcome from './StudyQuizQuestionWelcome'
import StudyQuizQuestionBasicInfo from './StudyQuizQuestionBasicInfo'
import StudyQuizQuestionMeasurements from './StudyQuizQuestionMeasurements'
import StudyQuizQuestionMedications from './StudyQuizQuestionMedications'
import StudyQuizQuestionMedicationPlan from './StudyQuizQuestionMedicationPlan'
import StudyQuizQuestionBloodGlucose from './StudyQuizQuestionBloodGlucose'
import StudyQuizQuestionHemoglobin from './StudyQuizQuestionHemoglobin'
import StudyQuizQuestionProblematic from './StudyQuizQuestionProblematic'
import StudyQuizQuestionLastWeeks from './StudyQuizQuestionLastWeeks'
import StudyQuizQuestionSelfManagement from './StudyQuizQuestionSelfManagement'
import StudyQuizQuestionPayment from './StudyQuizQuestionPayment'
import StudyQuizQuestionLast from './StudyQuizQuestionLast'
import StudyQuizQuestionDiagnosed from './StudyQuizQuestionDiagnosed'
import StudyQuizModal from './StudyQuizModal.vue'

export default {
    components: { 
        StudyQuizQuestionWelcome,
        StudyQuizQuestionBasicInfo,
        StudyQuizQuestionMeasurements,
        StudyQuizQuestionMedications,
        StudyQuizQuestionMedicationPlan,
        StudyQuizQuestionBloodGlucose,
        StudyQuizQuestionHemoglobin,
        StudyQuizQuestionProblematic,
        StudyQuizQuestionLastWeeks,
        StudyQuizQuestionSelfManagement,
        StudyQuizQuestionPayment,
        StudyQuizQuestionLast,
        StudyQuizQuestionDiagnosed,
        StudyQuizModal
    },

    props: {
        uuid: {
            type: String,
            required: true
        },
        lastTab: {
            type: Number,
            default: 1,
            required: false
        },
        type: {
            type: String,
            required: true
        },
        completed: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            questionNumber: this.lastTab,
            numberOfTabs: this.type === 'first' ? 12 : 11,
            showBackButton: true,
            apiData: {}
        }
    },

    watch: {
        questionNumber: {
            immediate: true,
            handler(value) {
                if (value < this.numberOfTabs) {
                    this.showBackButton = true
                } else {
                    this.showBackButton = false
                }

                this.replaceUrl()
            }
        },
    },

    mounted() {
        let uri = new URI(location.href)

        this.replaceUrl()
        
        if (uri.hasQuery('step')) {
            this.questionNumber = parseInt(uri.search(true).step)
        }

        if(this.questionNumber === this.numberOfTabs) {
            this.showBackButton = false
        }

        if(this.completed != "") {
            this.questionNumber = this.numberOfTabs
        }
    },

    computed: {
        tabs() {
            if (this.type === 'first') {
                return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            } else {
                return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            }
        },
    },

    methods: {
        getComponent(tab) {
            let components = {}

            if(this.type === 'first') {
                components = {
                    1: 'study-quiz-question-welcome',
                    2: 'study-quiz-question-basic-info',
                    3: 'study-quiz-question-measurements',
                    4: 'study-quiz-question-diagnosed',
                    5: 'study-quiz-question-blood-glucose',
                    6: 'study-quiz-question-hemoglobin',
                    7: 'study-quiz-question-medications',
                    8: 'study-quiz-question-medication-plan',
                    9: 'study-quiz-question-last-weeks',
                    10: 'study-quiz-question-problematic',
                    11: 'study-quiz-question-self-management',
                    12: 'study-quiz-question-last',
                };
            } else {
                components = {
                    1: 'study-quiz-question-welcome',
                    2: 'study-quiz-question-measurements',
                    3: 'study-quiz-question-blood-glucose',
                    4: 'study-quiz-question-hemoglobin',
                    5: 'study-quiz-question-medications',
                    6: 'study-quiz-question-medication-plan',
                    7: 'study-quiz-question-last-weeks',
                    8: 'study-quiz-question-problematic',
                    9: 'study-quiz-question-self-management',
                    10: 'study-quiz-question-payment',
                    11: 'study-quiz-question-last',
                };
            }
            
            return components[tab];
        },

        setDataFromChild(apiData, next) { 
            var that = this
            $('html, body').animate({scrollTop: $("#page").offset().top}, 0)

            if(apiData) {
                for (const [key] of Object.entries(apiData)) {
                    that.apiData[apiData[key]['key']] = apiData[key]['value']
                }
            }

            if(next) {
                this.nextTab()
            }
        },

        prevTab() {
            if(this.questionNumber === 1) {
                window.location.replace('/')
            } else {
                this.questionNumber = this.questionNumber - 1
            }
        },

        nextTab() {
            this.questionNumber = this.questionNumber + 1
        },

        replaceUrl() {
            var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?step='+this.questionNumber;   
            window.history.replaceState({ path: refresh }, '', refresh);
        },

        showTab(tab) {
            return this.questionNumber === tab;
        },
    }
}
</script>